import React, { useEffect, useState } from "react";
import PartnerLayout, { tenantSlugFor, usePartnerActiveTenant } from "@/components/PartnerLayout";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import BulkImportCSVModal from "@/components/BulkImportCSVModal";
import { Upload } from "lucide-react";

export default function Alumnos() {
  const { user } = useAuth();
  const slug = usePartnerActiveTenant(user) || tenantSlugFor(user);
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [showImport, setShowImport] = useState(false);

  const load = () => {
    if (!slug) return;
    const p = search ? `?search=${encodeURIComponent(search)}` : "";
    api.get(`/partner/${slug}/students${p}`).then((r) => setItems(r.data)).catch(() => {});
  };

  useEffect(() => { load(); }, [slug, search]);

  return (
    <PartnerLayout user={user}>
      <div>
        <div className="flex items-end justify-between mb-4">
          <div>
            <p className="text-xs uppercase tracking-widest text-brand-orange-500 font-semibold">Alumnos</p>
            <h1 className="mt-2 text-3xl font-bold text-white font-display">{items.length} alumnos</h1>
            <p className="text-xs text-gray-500 mt-1 font-mono">/t/{slug}</p>
          </div>
          <button onClick={() => setShowImport(true)}
            data-testid="bulk-import-btn"
            className="inline-flex items-center gap-1 px-4 py-2 rounded-md bg-brand-orange-600 hover:bg-brand-orange-500 text-white text-sm font-semibold">
            <Upload className="w-4 h-4" /> Importar CSV
          </button>
        </div>
        <input placeholder="Buscar por nombre o email..." value={search} onChange={(e) => setSearch(e.target.value)}
          data-testid="students-search"
          className="mt-4 bg-[#111827] border border-gray-800 rounded-md px-3 py-2 text-sm text-white focus:border-brand-orange-500 outline-none w-full max-w-md" />

        <div className="mt-6 overflow-x-auto border border-gray-800 rounded-xl">
          <table className="w-full text-sm">
            <thead className="bg-[#0F172A] text-xs uppercase tracking-widest text-gray-400">
              <tr>
                <th className="text-left px-4 py-3">Alumno</th>
                <th className="text-left px-4 py-3">Programas</th>
                <th className="text-left px-4 py-3">Progreso prom.</th>
                <th className="text-left px-4 py-3">Certificados</th>
              </tr>
            </thead>
            <tbody>
              {items.map((s) => (
                <tr key={s.id} className="border-t border-gray-800 hover:bg-white/[0.02]" data-testid={`student-row-${s.email}`}>
                  <td className="px-4 py-3">
                    <p className="text-white font-medium">{s.full_name}</p>
                    <p className="text-xs text-gray-500 font-mono">{s.email}</p>
                  </td>
                  <td className="px-4 py-3 text-white">{s.enrollments_count}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-24 h-1.5 bg-white/10 rounded-full overflow-hidden">
                        <div className="h-full bg-brand-orange-500" style={{ width: `${s.avg_progress_percent}%` }} />
                      </div>
                      <span className="font-mono text-xs text-white">{s.avg_progress_percent}%</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-white">{s.certificates_count}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={4} className="px-4 py-10 text-center text-gray-500">Sin alumnos.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {showImport && <BulkImportCSVModal tenantSlug={slug} onClose={() => setShowImport(false)} onDone={() => { load(); setShowImport(false); }} />}
    </PartnerLayout>
  );
}
